import { initOrderApi } from './init';
import { passportCheckApi } from './passport';
import {
    verifySmsFinishApi,
    requestSmsCodeApi,
    deliveryResendSmsCodeApi,
    verifySmsApi,
} from './sms';
import { deliveriesBookSlotApi } from './time-slots';
import { deliveriesSearchApi } from './deliveries';
import { draftsCheckApi, draftRestoreApi } from './drafts';
import { finishApi } from './finish';
import { getCategoriesApi } from './categories';

export const api = {
    passportCheck: passportCheckApi,
    draftsCheck: draftsCheckApi,
    draftRestore: draftRestoreApi,
    deliveriesSearch: deliveriesSearchApi,
    finishOrder: finishApi,
    initOrder: initOrderApi,
    requestSmsCode: requestSmsCodeApi,
    verifySms: verifySmsApi,
    deliveryResendSmsCode: deliveryResendSmsCodeApi,
    bookTimeSlot: deliveriesBookSlotApi,
    verifySmsFinish: verifySmsFinishApi,
    getCashbackCategories: getCategoriesApi,
};
